export const partnerDashboardSagaActionTypes = {
  callGetPartnerDashboardSaga: "callGetPartnerDashboardSaga",
  callUpdatePartnerSupportLevelSaga: "callUpdatePartnerSupportLevelSaga",
  callSendContractReminderSaga: "callSendContractReminderSaga",
};

export type UpdatePartnerSupportLevelPayload = {
  partnerId: number;
  support_level: string;
  support_status: number;
};

export const getPartnerDashboardSagaAction: (partnerId: number) => {
  type: string;
  partnerId: number;
} = (partnerId) => ({
  type: partnerDashboardSagaActionTypes.callGetPartnerDashboardSaga,
  partnerId,
});

export const updatePartnerSupportLevelSagaAction = (
  payload: UpdatePartnerSupportLevelPayload
) => ({
  type: partnerDashboardSagaActionTypes.callUpdatePartnerSupportLevelSaga,
  payload,
});

export const sendContractReminderSagaAction = (partnerId: number) => ({
  type: partnerDashboardSagaActionTypes.callSendContractReminderSaga,
  payload: { partnerId },
});
